var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.587821,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 5.33333C6.66675 8.27885 9.05456 10.6667 12.0001 10.6667C14.9456 10.6667 17.3334 8.27885 17.3334 5.33333C17.3334 2.38781 14.9456 0 12.0001 0C9.05456 0 6.66675 2.38781 6.66675 5.33333ZM20.0001 10.6667C20.0001 12.8758 21.7909 14.6667 24.0001 14.6667C26.2092 14.6667 28.0001 12.8758 28.0001 10.6667C28.0001 8.45753 26.2092 6.66667 24.0001 6.66667C21.7909 6.66667 20.0001 8.45753 20.0001 10.6667Z",
    fill: "#8280FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9778 13.3333C5.68255 13.3333 0.517678 16.5686 0.000868912 22.9322C-0.0272823 23.2788 0.635616 23.9999 0.970003 23.9999H22.9956C23.9972 23.9999 24.0128 23.1939 23.9972 22.9333C23.6065 16.3908 18.3616 13.3333 11.9778 13.3333ZM31.2746 23.9999L26.1333 23.9999C26.1333 20.9987 25.1417 18.229 23.4683 16.0007C28.0103 16.0504 31.7189 18.3468 31.998 23.1999C32.0092 23.3954 31.998 23.9999 31.2746 23.9999Z",
    fill: "#8280FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.97526db4fb3ffe8be123f729d7f7f591.svg";
export { ForwardRef as ReactComponent };